import { getEnv } from '@/env';
import { queryURLparams } from '.';

export const query = queryURLparams();

let _baseStaticUrl = '';

export const ENV = getEnv(import.meta.env.MODE);

/**
 * 获取静态资源的基本路径
 */
const getBaseStaticUrl = () => {
  const origin = window.location.origin;
  const path = ENV.routerBase;

  return origin + path;
};

_baseStaticUrl = getBaseStaticUrl();

export const baseStaticUrl = _baseStaticUrl; // 静态资源的基本路径

export const superAdmin = 'common_1';

export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
